import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { TranslateService } from '@ngx-translate/core';

import { ToastService } from '../../../../services/toast.service';
import { SKILL_API_BASE } from '../constants/skill-api.constants';

const HTTP_STATUS = {
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PRECONDITION_FAILED: 412,
  TOO_MANY_REQUESTS: 429,
  SERVICE_UNAVAILABLE: 503,
};

const ERROR_MESSAGES = {
  FORBIDDEN: 'SKILL_LEARNING_INTERCEPTOR_FORBIDDEN',
  NOT_FOUND: 'SKILL_LEARNING_INTERCEPTOR_NOT_FOUND',
  CONFLICT: 'SKILL_LEARNING_INTERCEPTOR_CONFLICT',
  PRECONDITION_FAILED: 'SKILL_LEARNING_INTERCEPTOR_PRECONDITION_FAILED',
  TOO_MANY_REQUESTS: 'SKILL_LEARNING_INTERCEPTOR_TOO_MANY_REQUESTS',
  SERVICE_UNAVAILABLE: 'SKILL_LEARNING_INTERCEPTOR_SERVICE_UNAVAILABLE',
};

@Injectable()
export class SkillLearningHttpInterceptor implements HttpInterceptor {

  constructor(
    private toastService: ToastService,
    private injector: Injector,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isSkillApiRequest(request)) {
      return next.handle(request);
    }
    return next.handle(request).catch(error => this.handleSkillApiError(error));
  }

  private isSkillApiRequest(request: HttpRequest<any>): boolean {
    return request.url.indexOf(SKILL_API_BASE) !== -1;
  }

  private handleSkillApiError(error: HttpErrorResponse): Observable<never> {
    if (!(error instanceof HttpErrorResponse)) {
      return Observable.throw(error);
    }
    this.notifyUserAboutError(error);
    return Observable.throw(error);
  }

  private notifyUserAboutError(error: HttpErrorResponse): void {
    switch (error.status) {
      case HTTP_STATUS.FORBIDDEN:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.FORBIDDEN));
        break;
      case HTTP_STATUS.NOT_FOUND:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.NOT_FOUND));
        break;
      case HTTP_STATUS.CONFLICT:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.CONFLICT));
        break;
      case HTTP_STATUS.PRECONDITION_FAILED:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.PRECONDITION_FAILED));
        break;
      case HTTP_STATUS.TOO_MANY_REQUESTS:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.TOO_MANY_REQUESTS));
        break;
      case HTTP_STATUS.SERVICE_UNAVAILABLE:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.SERVICE_UNAVAILABLE));
        break;
    }
  }

  private translateMessage(key: string): string {
    return this.injector.get(TranslateService).instant(key);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/interceptors/skill-learning-http.interceptor.ts